import React from 'react';
import { Settings } from 'lucide-react';
import { Wheel as RouWheel } from 'react-custom-roulette';
import CustomWheelFrame from '../customWheel/CustomWheelFrame';
import './WheelPagePreview.css';

const MOCK_PRIZES = [
    { option: 'TÚI XÁCH' },
    { option: 'MÓC KHÓA' },
    { option: 'Áo thun' },
    { option: 'ÁO MƯA' },
];

const previewWheelProps = {
    backgroundColors: [
        '#84CC16', '#10B981', '#7C3AED', '#DC2626', '#F97316',
        '#94A3B8', '#1E3A5F', '#38BDF8', '#FACC15',
    ],
    textColors: ['#FFFFFF'],
    outerBorderColor: 'transparent',
    outerBorderWidth: 0,
    innerBorderColor: '#D4AF37',
    innerBorderWidth: 3,
    innerRadius: 20,
    radiusLineColor: 'rgba(255, 255, 255, 0.35)',
    radiusLineWidth: 2,
    fontFamily: 'Nunito',
    fontWeight: 'bold',
    fontSize: 11,
    fontStyle: 'normal',
    textDistance: 58,
    spinDuration: 1.0,
    pointerProps: { style: { opacity: 0, width: 0, height: 0 } },
};

const FOOTER_ITEMS = [
    'Hotline: 0941.003.456',
    'Cơ sở 1: 86 Lê Duẩn - tt Khe Sanh',
    'Cơ sở 2: 172 Lê Duẩn - tt Khe Sanh',
    'Cơ sở 3: 115 Lê Duẩn - tt Khe Sanh',
];

const WheelPagePreview = ({ backgroundUrl }) => {
    if (!backgroundUrl) return null;

    return (
        <div className="wheel-page-preview-wrap">
            <div
                className="wheel-page-preview"
                style={{
                    backgroundImage: `url(${backgroundUrl})`,
                }}
            >
                <div className="wheel-page-preview__setting" aria-hidden="true">
                    <Settings size={14} />
                </div>

                <div className="wheel-page-preview__wheel-area">
                    <button type="button" className="wheel-page-preview__spin-btn" disabled>
                        Quay Ngay!
                    </button>
                    <div className="wheel-page-preview__wheel-scale">
                        <CustomWheelFrame>
                            <RouWheel
                                mustStartSpinning={false}
                                prizeNumber={0}
                                data={MOCK_PRIZES}
                                onStopSpinning={() => {}}
                                {...previewWheelProps}
                            />
                        </CustomWheelFrame>
                    </div>
                </div>

                <div className="wheel-page-preview__footer">
                    <div className="wheel-page-preview__marquee">
                        {FOOTER_ITEMS.map((item) => (
                            <span key={item}>{item}</span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WheelPagePreview;
